<script>
import Licence from './Licence.vue'

export default {
  name: 'CompanyModal',
  components: { Licence },
  props: {
    value: {
      type: Object,
      default: () => ({
        licenceKey: '4000001',
        licenceType: 'GCP',
        licenseeName: 'GS1 Germany GmbH',
        licenseeGLN: '4000001000005',
        licensingMO: {
          moName: 'GS1 Germany'
        },
        contactPoint: [{ website: 'https://www.gs1-germany.de' }],
        address: {
          postalName: {
            language: 'de',
            value: 'GS1 Germany GmbH'
          },
          countryCode: 'DE',
          addressLocality: {
            language: 'de',
            value: 'Köln'
          },
          streetAddress: {
            language: 'de',
            value: 'Maarweg 133'
          },
          postalCode: '50825'
        },
        dateCreated: '2018-05-21T20:15:34Z',
        dateUpdated: '2023-10-26T14:31:07.5283259Z'
      })
    }
  },
  data: () => ({
    id: 'company-modal-' + Math.random().toString(10).substring(2),
    selectedTab: 0
  }),
  methods: {
    test () {
      return null
    }
  },
  computed: {
    datActive () {
      return this.product ? 'active' : ''
    }
  }
}

</script>

<template>
  <div>
    <div
      data-toggle='modal'
      :data-target="'#' + id"
      style='cursor: pointer'
    >
      <slot>
        <span class='fa fa-list-alt' />
      </slot>
    </div>
    <div class='modal fade' :id='id' tabindex='-1'>
      <div class='modal-dialog modal-lg'>
        <div class='modal-content'>

          <div class='modal-header' style='border-top: none'>
            <button type='button' class='close' data-dismiss='modal'>
              <span>×</span>
            </button>
            <h4 class='modal-title' style='margin: 0; color: rgb(51, 51, 51)'>{{ value.licenseeName }}</h4>
          </div>
          <div class='modal-body'>
            <Licence :licence='value' />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/CompanyModal.vue